/* eslint-disable import/no-cycle */
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  newDriver: null,
  status: '',
  userInfo: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
